import { simpleSet } from '@r/reducers/utils';

const setCalculationModeToeKickType = simpleSet as
  redux.reducers.calculationMode.settings.dimensions.toeKickType;

export const toeKickType = setCalculationModeToeKickType(
  'SET_CALCULATION_MODE_TOE_KICK_TYPE',
  'toFloor'
);
